import { __read, __assign, __awaiter, __generator } from '../../external/tslib/tslib.es6.mjs.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import dayjs from 'dayjs';
import { useState, cloneElement } from 'react';
import { Button } from '../../base/button/Button.js';
import { ListCard } from '../../base/listCard/ListCard.js';
import { constants } from '../../constants/index.js';
import { DocumentIcon } from '../documentIcon/DocumentIcon.js';
import { Alert } from '../../base/alert/Alert.js';
import { documentsTypes } from '../documentsTypes/index.js';
import styles from './DocumentRow.module.scss.js';
import { Skeleton } from './skeleton/Skeleton.js';

var getName = function (document) {
    if ([documentsTypes.KEY_FACTS_SHEET, documentsTypes.KEY_FACTS_SHEET_2, documentsTypes.KEY_FACTS_SHEET_3].includes(document.Id)) {
        return 'Key Fact Sheet';
    }
    if (document.Id === documentsTypes.ENDORSEMENT_COVER_LETTER) {
        return 'Policy Change Letter';
    }
    return document.Description;
};
var DocumentRow = function (_a) {
    var document = _a.document, showIcon = _a.showIcon, hideDate = _a.hideDate, onViewClick = _a.onViewClick;
    var _b = __read(useState(null), 2), viewState = _b[0], setViewState = _b[1];
    var handleViewClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var url;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (document.onClick) {
                        document.onClick();
                        return [2 /*return*/];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    setViewState('loading');
                    return [4 /*yield*/, onViewClick(document)];
                case 2:
                    url = _b.sent();
                    setViewState(null);
                    window.open(url);
                    return [3 /*break*/, 4];
                case 3:
                    _b.sent();
                    setViewState('error');
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (jsxs(ListCard.Row, __assign({ className: styles.row, "data-testid": "document-row" }, { children: [jsxs("div", __assign({ className: styles.rowContent }, { children: [showIcon && jsx(DocumentIcon, { documentId: document.Id, className: styles.icon }), jsxs("div", __assign({ className: styles.details }, { children: [jsx("p", __assign({ className: styles.name }, { children: getName(document) })), !hideDate && (jsx("span", __assign({ className: styles.date }, { children: dayjs(document.DocumentDate).format(constants.DATE_SHORT_MONTH_FORMAT) }))), jsx(Button, __assign({ className: styles.mobileViewButton, onClick: handleViewClick, isLoading: document.isLoading || viewState === 'loading', disabled: document.isLoading || viewState === 'loading', variant: "text" }, { children: getName(document) }))] })), jsx(Button, __assign({ isLoading: document.isLoading || viewState === 'loading', disabled: document.isLoading || viewState === 'loading', onClick: handleViewClick, size: "xs", className: styles.desktopViewButton, variant: "outlined" }, { children: document.cta || 'View' }))] })), viewState === 'error' && (jsx(Alert, __assign({ variant: "error", title: "We were unable to open this document.", className: styles.error, hideIcon: true }, { children: jsx(Button, __assign({ onClick: handleViewClick, size: "xs", color: "dark" }, { children: "Try again" })) }))), document.error ? cloneElement(document.error, { className: styles.error }) : null] })));
};
DocumentRow.Skeleton = Skeleton;

export { DocumentRow };
